import { FrameName } from "../config";
import { type TileEntityWithOnBuildMethod } from "../TileEntity";
import HillsScoutTowerBuildingTileEntity from "./HillsScoutTowerBuildingTileEntity";

class MountainsScoutTowerBuildingTileEntity
	extends HillsScoutTowerBuildingTileEntity
	implements TileEntityWithOnBuildMethod
{
	public static readonly frameName = FrameName.MOUNTAINS_SCOUT_TOWER;
}

export default MountainsScoutTowerBuildingTileEntity;
